/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */
import type {
    QueryClient,
    QueryKey,
    QueryObserverOptions,
    UseQueryResult,
} from '@tanstack/react-query'
import { queryOptions, useQuery } from '@tanstack/react-query'

import fetch from 'Common/utils/query/workRequestClient.ts'
import type {
    RequestConfig,
    ResponseConfig,
    ResponseErrorConfig,
} from 'Common/utils/query/workRequestClient.ts'

import type { GetV1AgencyrightssubcategoryQueryResponse } from '../../types/GetV1Agencyrightssubcategory.ts'

export const getV1AgencyrightssubcategoryQueryKey = () =>
    [{ url: '/v1/AgencyRightsSubCategory' }] as const

export type GetV1AgencyrightssubcategoryQueryKey = ReturnType<
    typeof getV1AgencyrightssubcategoryQueryKey
>

/**
 * {@link /v1/AgencyRightsSubCategory}
 */
export async function getV1Agencyrightssubcategory(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const { client: request = fetch, ...requestConfig } = config

    const res = await request<
        GetV1AgencyrightssubcategoryQueryResponse,
        ResponseErrorConfig<Error>,
        unknown
    >({ method: 'GET', url: `/v1/AgencyRightsSubCategory`, ...requestConfig })
    return res
}

export function getV1AgencyrightssubcategoryQueryOptions(
    config: Partial<RequestConfig> & { client?: typeof fetch } = {},
) {
    const queryKey = getV1AgencyrightssubcategoryQueryKey()
    return queryOptions<
        ResponseConfig<GetV1AgencyrightssubcategoryQueryResponse>,
        ResponseErrorConfig<Error>,
        ResponseConfig<GetV1AgencyrightssubcategoryQueryResponse>,
        typeof queryKey
    >({
        queryKey,
        queryFn: async ({ signal }) => {
            config.signal = signal
            return getV1Agencyrightssubcategory(config)
        },
    })
}

/**
 * {@link /v1/AgencyRightsSubCategory}
 */
export function useGetV1Agencyrightssubcategory<
    TData = ResponseConfig<GetV1AgencyrightssubcategoryQueryResponse>,
    TQueryData = ResponseConfig<GetV1AgencyrightssubcategoryQueryResponse>,
    TQueryKey extends QueryKey = GetV1AgencyrightssubcategoryQueryKey,
>(
    options: {
        query?: Partial<
            QueryObserverOptions<
                ResponseConfig<GetV1AgencyrightssubcategoryQueryResponse>,
                ResponseErrorConfig<Error>,
                TData,
                TQueryData,
                TQueryKey
            >
        > & { client?: QueryClient }
        client?: Partial<RequestConfig> & { client?: typeof fetch }
    } = {},
) {
    const { query: queryConfig = {}, client: config = {} } = options ?? {}
    const { client: queryClient, ...queryOptions } = queryConfig
    const queryKey = queryOptions?.queryKey ?? getV1AgencyrightssubcategoryQueryKey()

    const query = useQuery(
        {
            ...getV1AgencyrightssubcategoryQueryOptions(config),
            queryKey,
            ...queryOptions,
        } as unknown as QueryObserverOptions,
        queryClient,
    ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & { queryKey: TQueryKey }

    query.queryKey = queryKey as TQueryKey

    return query
}
